import styled from 'styled-components';
import { customMedia } from 'styles/utils';

import Button from 'components/Button';

export const SearchForm = styled.form(({ theme, inverted, variant }) => {
  let styleSheet = {
    display: 'flex',
    alignItems: 'center',
    borderLeft: `1px solid ${theme.color.wfGrey700}`,
    borderRight: `1px solid ${theme.color.wfGrey700}`,
    background: inverted ? theme.color.wfWhite : theme.color.wfBlack,
  };

  if (variant === 'outlined') {
    styleSheet = {
      ...styleSheet,
      border: `1px solid ${theme.color.wfGrey700}`,
      borderRadius: 100,
    };
  }

  return styleSheet;
});

export const SearchInput = styled.input(({ theme, inverted, variant }) => ({
  width: '100%',
  padding: theme.space[2],
  height: variant === 'outlined' ? 40 : 32,
  borderRadius: variant === 'outlined' ? 100 : 0,
  background: inverted ? theme.color.wfWhite : theme.color.wfBlack,
  boxSizing: 'border-box',
  fontSize: theme.font.size.xsmall,
  color: inverted ? theme.color.wfBlack : theme.color.wfWhite,
  '&::placeholder': {
    color: theme.color.wfGrey700,
  },
}));

export const SearchButton = styled(Button)`
  margin-left: ${props => props.theme.space[2]};
  border: none;
  background-color: transparent;
  padding: 0;
  svg {
    path {
      fill: ${props => props.theme.color.wfGrey700};
    }
  }
`;

export const SearchWrapper = styled.div`
  min-width: 40px;
  position: relative;

  ${customMedia.greaterThan('large')`
    display: ${props => (!props.isMobile ? 'block' : 'none')};
  `}
  ${customMedia.lessThan('large')`
    display: ${props => (props.isMobile ? 'block' : 'none')};
    margin: ${props => props.theme.spacing.default};
  `}
  ${customMedia.between('large', 'sxlarge')`
    display: none;
  `};
`;
